<template>
  <div class="widget" style="z-index: 1">
    <div class="widget-label">
      <div class="label">
        <p>Project Goals</p>
      </div>
    </div>
    <div class="widget-content">
      <b-row v-if="accountUser.admin == true">
        <b-col cols="12">
          <div 
            v-if="isKickoffOpen"
            class="mb-2 custom-search dark position-relative"
          >
            <b-form @submit.prevent="onAddGoalSubmit">
              <b-form-group label="Add a goal" label-for="goal-name">
                <div class="d-flex">
                  <b-form-input
                    id="goal-name"
                    v-model="form.name"
                    maxlength="500"
                    @blur="onGoalFormBlur"
                  ></b-form-input>
                  <b-button
                    type="submit"
                    :disabled="sending || form.name.length === 0"
                  >
                    <b-spinner v-if="sending" small label="Spinning" />
                    <div v-else>Add</div>
                  </b-button>
                </div>
              </b-form-group>
            </b-form>
            <BaseMessageBlock :messages="errors"></BaseMessageBlock>
          </div>
          <div 
            v-if="hasGoals"
            class="d-flex"
          >
            <b-badge 
              v-for="goal in goals"
              :key="goal.goalId"
              variant="secondary"
              class="mr-1 badge-tag"
              style="font-size: var(--body-p);"
              :draggable="isKickoffOpen"
              @dragstart="startGoalDrag($event, goal.goalId)"
              @drop.prevent="onGoalDrop($event, goal.goalId)"
              @dragover.prevent
            >
              <span class="d-inline-block py-2">{{ goal.name }}</span>
              <b-button 
                v-if="isKickoffOpen && accountUser.admin == true"
                variant="link" 
                class="btn-delete text-white pr-0 text-decoration-none"
                @click="showDeleteConfirmation(goal)"
              >
                &times;<span class="sr-only"> Delete</span>
              </b-button>
            </b-badge>
          </div>
          <p 
            v-else
            class="text-center mt-3"
          >
            {{
              isKickoffOpen
                ? (emptyText = "Add a goal!")
                : (emptyText = "No Goals for this meeting")
            }}
          </p>
        </b-col>
      </b-row>
    </div>
    <BaseConfirmationModal
      ref="del-goal-confirmation"
      title="Delete Goal"
      :message="deletingGoalMessage"
      okText="Delete"
      @submit="onDeleteGoalConfirm"
      @cancel="cancelDelete"
    ></BaseConfirmationModal>
  </div>
</template>
<script>
import axios from "axios";
import pmMixin from "@/mixins/project-metric-mixin.js";
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";

export default {
  name: "KickoffGoals",
  components: {
    BaseConfirmationModal,
  },
  mixins: {
    pmMixin,
  },
  props: {
    projectId: {
      type: String,
      default: "",
      required: true
    },
    projectName: {
      type: String,
      default: "",
      required: true
    },
    status: {
      type: String,
      default: "",
      required: true
    },
    meetingId: {
      type: String,
      default: "",
      required: true
    },
  },
  data() {
    return {
      errors: [],
      form: {
        name: ''
      },
      deletingGoalId: "",
      deletingGoalMessage: "",
      editingGoalId: "",
      dragGoalId: '',
      sending: false,
      showModal: false,
      allUsersName: [],
      starFill: "star-fill",
      starEmpty: "star",
      testArray: [],
      emptyText: "No Goals To Show!",
      user: "",
      goals: [],
    };
  },
  computed: {
    isKickoffOpen() {
      return this.status === "Open";
      // return this.status != "Closed";
    },
    columnCountClass() {
      return this.goals.length >= 4 ? 'column-count-2-sm' : '';
    },
    hasGoals() {
      return this.goals.length > 0;
    },
  },
  watch: {
    goals(goals) {
      this.$emit("goalsUpdated", goals);
    }
  },
  mounted() {
    this.loadGoals();
  },
  methods: {
    show() {
      return (this.showModal = true);
    },
    hide() {
      return (this.showModal = false);
    },
    cancel() {
      this.reset();
      this.hide();
    },
    reset() {
      this.deletingGoalId = "";
      this.deletingGoalMessage = "";
      this.editingGoalId = "";
      this.sending = false;
    },
    onGoalFormBlur() {
      if (this.form.name.trim().length === 0) {
        this.errors = [];
      }
    },
    loadGoals() {
      axios
        .get(
          `${this.$api_url}/goals/${this.projectId}`,
          this.getReqConfig()
        )
        .then((response) => {
          this.goals = response.data;
          this.goals.sort((a, b) => this.$helpers.compareInt(a.sortOrder, b.sortOrder));
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    validateGoal(goal){
      const initErrors = this.errors.length;
      let name = goal.name.trim();

      if (!name.length) {
        this.errors.push({message: 'Goal name cannot be empty' })
      } else if (this.goals.find(g => g.name.trim().toLowerCase() === name.toLowerCase())){
        this.errors.push({
          message: `Goal "${name}" is already part of this project`
        });
      }

      return initErrors === this.errors.length;
    },
    onAddGoalSubmit() {
      if (this.form.name.length === 0) {
        return;
      }
      let goal = {
        goalId: this.$helpers.generateUUID(),
        projectId: this.projectId,
        name: this.form.name,
        desc: '',
        sortOrder: this.goals.length
      };

      if (!this.validateGoal(goal)) {
        return;
      }

      this.sending = true;

      axios
        .put(
          `${this.$api_url}/put-goal/${goal.goalId}`,
          goal,
          this.getReqConfig()
        )
        .then(() => {
          this.goals.push(goal);
          this.goals.sort((a, b) => this.$helpers.compareInt(a.sortOrder, b.sortOrder));
          this.form.name = "";
          this.errors = [];
        })
        .catch(() => {
          //Do something about it
        })
        .finally(() => {
          this.sending = false;
          this.$emit("refresh", this.meetingId);
        });
      
    },
    showDeleteConfirmation(goal) {
      this.deletingGoalId = goal.goalId;
      this.deletingGoalMessage = `Are you sure you want to delete "${goal.name}"?`;
      this.$refs["del-goal-confirmation"].show();
    },
    cancelDelete() {
      this.deletingGoalId = "";
    },
    onDeleteGoalConfirm() {
      const deletingGoalId = this.deletingGoalId;
      const goal = this.goals.find(
        (g) => g.goalId === deletingGoalId
      );
      goal.sending = true;

      axios
        .delete(
          `${this.$api_url}/delete-goal/${this.deletingGoalId}`,
          this.getReqConfig()
        )
        .then(() => {
          this.goals = this.goals.filter(g => g.goalId !== deletingGoalId);
        })
        .catch(() => {
        })
        .finally(() => {
          goal.sending = false;
        });
    },
    startGoalDrag(event, id) {
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      this.dragGoalId = id;
    },
    onGoalDrop(event, dropzoneGoalId) {
      if ( this.dragGoalId !== dropzoneGoalId ) {

        const oldIndex = this.goals.findIndex(q => q.goalId === this.dragGoalId),
          insertAfterIndex = this.goals.findIndex(q => q.goalId === dropzoneGoalId);

        this.changeGoalPosition(oldIndex,insertAfterIndex);
        this.renumberGoalsOrder();
        this.updateAllGoals();
      }
    },
    changeGoalPosition(oldIndex,insertAfterIndex) {
      if ( oldIndex === insertAfterIndex || oldIndex === insertAfterIndex + 1 ) {
        return;
      }

      const newIndex = oldIndex < insertAfterIndex ? insertAfterIndex : insertAfterIndex + 1,
        goalCopy = {...this.goals[oldIndex]};

      this.goals.splice(oldIndex, 1);
      this.goals.splice(newIndex, 0, goalCopy);
    },
    renumberGoalsOrder(startIndex = 0) {
      this.goals.forEach(q => {
        q.sortOrder = startIndex++;
      });
    },
    updateAllGoals() {
      this.goals.forEach(goal => { 
        this.updateGoal(goal); 
      });
    },
    updateGoal(goal) {
      axios
        .put(
          `${this.$api_url}/put-goal/${goal.goalId}`,
          goal,
          this.getReqConfig()
        )
        .then(() => {
        })
        .catch(() => {
        })
        .finally(() => {
        });
      
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-search {
  &__modal {
    background: white;
    border-radius: 4px;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    transition: all 0.15s ease-in-out;

    &.open {
      top: 42px;
      opacity: 1;
      height: auto;
      z-index: 2;
    }
  }
  &__result {
    position: absolute;
    height: 100%;
    left: 48px;
    top: 0px;
    display: flex;
    align-items: center;
    pointer-events: none;
    font-size: var(--body-p);
    opacity: 0.2;
    &--left-over {
      background: #90a0b7;
    }
  }
}
.badge-tag {
  .btn-delete {
    display: none;
  }
  &:hover .btn-delete {
    display: inline-block;
  }
}
</style>